import type { PlacePreviewProperties } from "~/lib/api";
import {
  isAccommodationPlaceProperties,
  isBackcountryPlaceProperties,
  isBikeParkPlaceProperties,
  isHikingPlaceProperties,
  isMtbTrailPlaceProperties,
  isMtbTrailRelatedPlace,
} from "~/lib/api";
import { AccommodationStats } from "./accommodation/AccommodationStats";
import { BackcountryStats } from "./backcountry/BackcountryStats";
import { TrailStats } from "./hiking/TrailStats";
import { BikeParkStats } from "./mtb/BikeParkStats";
import { MtbTrailStats } from "./mtb/MtbTrailStats";

interface PlaceStatsProps {
  properties: PlacePreviewProperties;
  compact?: boolean;
  outline?: boolean;
  className?: string;
  fallback?: React.ReactNode;
}

export function PlaceStats({ properties, compact, outline, className, fallback }: PlaceStatsProps) {
  if (isHikingPlaceProperties(properties)) {
    return <TrailStats metadata={properties.metadata} compact={compact} outline={outline} className={className} />;
  }
  if (isBackcountryPlaceProperties(properties)) {
    return (
      <BackcountryStats metadata={properties.metadata} compact={compact} outline={outline} className={className} />
    );
  }
  if (isMtbTrailPlaceProperties(properties)) {
    return <MtbTrailStats metadata={properties.metadata} compact={compact} outline={outline} className={className} />;
  }
  if (isAccommodationPlaceProperties(properties)) {
    return (
      <AccommodationStats metadata={properties.metadata} compact={compact} outline={outline} className={className} />
    );
  }
  if (isBikeParkPlaceProperties(properties)) {
    const trails = properties.relatedPlaces?.filter(isMtbTrailRelatedPlace) ?? [];
    return (
      <BikeParkStats
        metadata={properties.metadata}
        trails={trails}
        compact={compact}
        outline={outline}
        className={className}
      />
    );
  }
  return <>{fallback}</>;
}
